var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-html" },
    [
      !_vm.hasSlotData
        ? _c("h4", {
            staticClass: "modal-html__name",
            domProps: { innerHTML: _vm._s(_vm.data.name) },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.hasSlotData
        ? _c("vue-raw", {
            staticClass: "modal-html__detail html-content",
            attrs: { raw: _vm.data.detail },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }